import { createContext } from "react"

const INIT_SCHEDULE_COMPONENT_CONTEXT = {
    changeReservationAttendance: (reservationId, value) => {}
};
const ScheduleComponentContext = createContext(INIT_SCHEDULE_COMPONENT_CONTEXT);

export default ScheduleComponentContext;